<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-icon left color="primary">mdi-chart-timeline-variant</v-icon>Setting · Budget
          Monitoring
          <v-spacer></v-spacer>
          <v-btn text color="primary" :to="'/report/budget-monitoring'">
            <v-icon left>mdi-arrow-left</v-icon>Ke laporan
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <!-- ================= Ambang & perhitungan ================= -->
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1 py-2">Ambang &amp; perhitungan</v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model.number="form.yellowFrom"
                        type="number"
                        label="Kuning mulai >"
                        suffix="%"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model.number="form.redFrom"
                        type="number"
                        label="Merah mulai >"
                        suffix="%"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model.number="form.lowConfidenceFrom"
                        type="number"
                        label="Low confidence >"
                        suffix="%"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-switch
                        v-model="form.includeFreight"
                        dense
                        hide-details
                        label="Freight PO supplier masuk belanja — PPN tidak pernah dihitung"
                      ></v-switch>
                      <v-switch
                        v-model="form.includeStockUsage"
                        dense
                        hide-details
                        label="Pemakaian stok (MR) dihitung ke pemakaian budget"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model.number="form.poLookbackMonths"
                        type="number"
                        label="PO CRM dipantau sejak"
                        suffix="bulan"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model.number="form.closedJobGraceDays"
                        type="number"
                        label="Job closed tetap dipantau"
                        suffix="hari"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="caption grey--text">
                      Perhitungan otomatis setiap jam (server). Terakhir:
                      <span v-if="lastRun"
                        >{{ formatDateTime(lastRun.finishedAt || lastRun.startedAt) }} ·
                        {{ lastRun.status }}</span
                      >
                      <span v-else>belum ada</span>
                    </v-col>
                  </v-row>
                  <v-alert type="warning" dense text class="mt-3 mb-0">
                    Mengubah ambang atau saklar dapat memindahkan band PO dan memicu email pada
                    perhitungan berikutnya.
                  </v-alert>
                </v-card-text>
                <v-card-actions class="px-4 pb-3">
                  <v-spacer></v-spacer>
                  <v-btn text @click="loadSetting">Batal</v-btn>
                  <v-btn color="primary" :loading="savingSetting" @click="saveSetting"
                    >Simpan</v-btn
                  >
                </v-card-actions>
              </v-card>

              <!-- ================= Override margin ================= -->
              <v-card outlined class="mt-4">
                <v-card-title class="subtitle-1 py-2">
                  Override margin
                  <v-spacer></v-spacer>
                  <span class="caption grey--text"
                    >dipakai hanya bila estimator dan quotation tidak punya margin</span
                  >
                </v-card-title>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>PO CRM</th>
                      <th>Customer</th>
                      <th>Sumber</th>
                      <th style="width: 110px">Margin %</th>
                      <th>Alasan</th>
                      <th style="width: 120px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in overrideRows" :key="row.crmPoId">
                      <td>
                        <router-link :to="'/report/budget-monitoring/po/' + row.crmPoId">{{
                          row.poNumber || "#" + row.crmPoId
                        }}</router-link>
                      </td>
                      <td class="caption">{{ row.customer || "—" }}</td>
                      <td>
                        <v-chip
                          x-small
                          :color="row.marginSource === 'OVERRIDE' ? 'primary' : 'grey lighten-2'"
                          :dark="row.marginSource === 'OVERRIDE'"
                          >{{ marginSourceLabel(row.marginSource) }}</v-chip
                        >
                      </td>
                      <td>
                        <v-text-field
                          v-model.number="row.marginPercent"
                          type="number"
                          dense
                          hide-details
                          suffix="%"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="row.reason"
                          dense
                          hide-details
                          placeholder="alasan"
                        ></v-text-field>
                      </td>
                      <td class="text-no-wrap">
                        <v-btn x-small color="primary" text @click="saveOverride(row)"
                          >Simpan</v-btn
                        >
                        <v-btn
                          x-small
                          color="error"
                          text
                          v-if="row.hasOverride"
                          @click="deleteOverride(row)"
                          >Hapus</v-btn
                        >
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <div class="d-flex align-center">
                          <v-text-field
                            v-model.number="newOverride.crmPoId"
                            type="number"
                            dense
                            hide-details
                            label="ID PO CRM"
                            class="mr-2"
                            style="max-width: 140px"
                          ></v-text-field>
                          <v-text-field
                            v-model.number="newOverride.marginPercent"
                            type="number"
                            dense
                            hide-details
                            label="Margin %"
                            class="mr-2"
                            style="max-width: 120px"
                          ></v-text-field>
                          <v-text-field
                            v-model="newOverride.reason"
                            dense
                            hide-details
                            label="Alasan"
                            class="mr-2"
                          ></v-text-field>
                          <v-btn small color="primary" text @click="saveOverride(newOverride, true)"
                            >+ tambah</v-btn
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>

            <!-- ================= Penerima email ================= -->
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1 py-2">
                  Penerima email
                  <v-spacer></v-spacer>
                  <v-btn small outlined color="primary" @click="testDialog = true">
                    <v-icon left small>mdi-email-check-outline</v-icon>Kirim email uji
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="4" v-for="type in types" :key="type.key">
                      <div class="pa-2 rounded" :class="type.headerClass">
                        <div class="font-weight-bold">{{ type.title }}</div>
                        <div class="caption">{{ type.subtitle }}</div>
                      </div>
                      <div
                        v-for="(r, i) in recipients[type.key]"
                        :key="i"
                        class="d-flex align-center mt-2"
                      >
                        <v-select
                          v-model="r.recipientType"
                          :items="['TO', 'CC']"
                          dense
                          hide-details
                          outlined
                          style="max-width: 80px"
                          class="mr-1"
                        ></v-select>
                        <v-combobox
                          v-model="r.email"
                          :items="placeholders"
                          dense
                          hide-details
                          outlined
                          placeholder="email atau @PO_SALES"
                        ></v-combobox>
                        <v-btn icon small color="error" @click="recipients[type.key].splice(i, 1)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <div
                        v-if="!(recipients[type.key] || []).length"
                        class="caption grey--text mt-2"
                      >
                        {{ type.emptyCopy }}
                      </div>
                      <div class="d-flex mt-2">
                        <v-btn x-small text color="primary" @click="addRecipient(type.key)"
                          >+ tambah penerima</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          x-small
                          color="primary"
                          :loading="savingRecipients === type.key"
                          @click="saveRecipients(type.key)"
                          >Simpan</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                  <div class="caption grey--text mt-3">
                    Placeholder: <code>@PO_SALES</code> / <code>@ASSIGNED_USER</code> = sales PO di CRM ·
                    <code>@PO_JOB_PIC</code> = PIC job di PPIC (aktif setelah PPIC menyediakan data
                    PIC).
                  </div>
                </v-card-text>
              </v-card>

              <!-- ================= Kurs ================= -->
              <v-card outlined class="mt-4">
                <v-card-title class="subtitle-1 py-2">Kurs</v-card-title>
                <v-card-text class="caption">
                  <ul class="pl-4">
                    <li>
                      Sumber: History Currency accounting (kurs tengah BI), mundur maksimal 7 hari
                      bila tanggal kosong.
                    </li>
                    <li>
                      Subtotal PO CRM dikonversi pada tanggal PO; PO supplier pada tanggal PO
                      supplier; PR tanpa PO pada tanggal PR.
                    </li>
                    <li>
                      Kurs tidak ditemukan → baris dihitung kurs 1 dan PO ditandai
                      <v-icon x-small color="error">mdi-currency-usd-off</v-icon>.
                    </li>
                  </ul>
                </v-card-text>
                <v-card-actions class="px-4 pb-3">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" :to="'/setting/currency'"
                    >Buka halaman Currency</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="testDialog" max-width="420px">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-3 px-4">Kirim email uji</v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="testEmail"
            label="Alamat tujuan"
            outlined
            dense
            hide-details
          ></v-text-field>
          <div class="caption grey--text mt-2">
            Mengirim contoh alert dengan angka §5.4 ke alamat ini.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="testDialog = false">Batal</v-btn>
          <v-btn color="primary" :loading="sendingTest" @click="sendTest">Kirim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import {
  NOTIFICATION_TYPES,
  RECIPIENT_PLACEHOLDERS,
  marginSourceLabel,
} from "@/utils/budgetMonitor";

export default {
  name: "budget-monitoring-setting",
  data: () => ({
    form: {
      yellowFrom: 80,
      redFrom: 100,
      lowConfidenceFrom: 50,
      includeFreight: true,
      includeStockUsage: true,
      poLookbackMonths: 18,
      closedJobGraceDays: 90,
    },
    savingSetting: false,
    recipients: { BUDGET_YELLOW: [], BUDGET_RED: [], BUDGET_RECOVERED: [] },
    savingRecipients: null,
    placeholders: RECIPIENT_PLACEHOLDERS,
    types: [
      {
        key: "BUDGET_YELLOW",
        title: "BUDGET_YELLOW",
        subtitle: "rasio masuk 80–100 %",
        headerClass: "amber lighten-4",
        emptyCopy: "Tidak ada penerima — mode bayangan, transisi hanya dicatat di log.",
      },
      {
        key: "BUDGET_RED",
        title: "BUDGET_RED",
        subtitle: "rasio > 100 %",
        headerClass: "red lighten-4",
        emptyCopy: "Tidak ada penerima — mode bayangan, transisi hanya dicatat di log.",
      },
      {
        key: "BUDGET_RECOVERED",
        title: "BUDGET_RECOVERED",
        subtitle: "turun dari MERAH ke KUNING",
        headerClass: "green lighten-4",
        emptyCopy: "Tidak ada penerima — email saat turun dari MERAH ke KUNING mati.",
      },
    ],
    overrides: [],
    noBudgetPos: [],
    newOverride: { crmPoId: null, marginPercent: null, reason: "" },
    testDialog: false,
    testEmail: "",
    sendingTest: false,
  }),
  computed: {
    ...mapGetters("budgetMonitor", ["lastRun"]),
    overrideRows() {
      const map = {};
      this.overrides.forEach(o => {
        map[o.crmPoId] = {
          crmPoId: o.crmPoId,
          marginPercent: o.marginPercent,
          reason: o.reason,
          hasOverride: true,
          marginSource: "OVERRIDE",
        };
      });
      this.noBudgetPos.forEach(p => {
        if (map[p.crmPoId]) {
          map[p.crmPoId].poNumber = p.poNumber;
          map[p.crmPoId].customer = p.customer;
          map[p.crmPoId].marginSource = p.marginSource;
        } else {
          map[p.crmPoId] = {
            crmPoId: p.crmPoId,
            poNumber: p.poNumber,
            customer: p.customer,
            marginSource: p.marginSource,
            marginPercent: null,
            reason: "",
            hasOverride: false,
          };
        }
      });
      return Object.values(map);
    },
  },
  created() {
    this.loadSetting();
    this.loadRecipients();
    this.loadOverrides();
    this.$store.dispatch("budgetMonitor/fetchRuns").catch(() => {});
    if (this.$route.query.po) {
      this.newOverride.crmPoId = Number(this.$route.query.po);
    }
  },
  methods: {
    marginSourceLabel,
    formatDateTime(d) {
      if (!d) return "—";
      const s = typeof d === "string" ? d : new Date(d).toISOString();
      return s.substring(0, 16).replace("T", " ");
    },
    toast(type, message) {
      this.$store.dispatch("toast", { type, message });
    },
    async loadSetting() {
      try {
        const s = await this.$store.dispatch("budgetMonitor/fetchSetting");
        if (s) this.form = { ...this.form, ...s };
      } catch (e) {
        this.toast("error", "Gagal memuat setting");
      }
    },
    async saveSetting() {
      this.savingSetting = true;
      try {
        await this.$store.dispatch("budgetMonitor/saveSetting", this.form);
        this.toast("success", "Setting tersimpan");
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message;
        this.toast("error", msg || "Gagal menyimpan setting");
      } finally {
        this.savingSetting = false;
      }
    },
    async loadRecipients() {
      try {
        const list = await this.$store.dispatch("budgetMonitor/fetchRecipients");
        const next = { BUDGET_YELLOW: [], BUDGET_RED: [], BUDGET_RECOVERED: [] };
        (list || []).forEach(r => {
          next[r.notificationType] = (r.recipients || []).map(x => ({ ...x }));
        });
        NOTIFICATION_TYPES.forEach(t => {
          if (!next[t]) next[t] = [];
        });
        this.recipients = next;
      } catch (e) {
        this.toast("error", "Gagal memuat penerima");
      }
    },
    addRecipient(type) {
      this.recipients[type].push({ recipientType: "TO", email: "" });
    },
    async saveRecipients(type) {
      this.savingRecipients = type;
      try {
        const rows = (this.recipients[type] || []).filter(r => r.email && String(r.email).trim());
        await this.$store.dispatch("budgetMonitor/saveRecipients", {
          notificationType: type,
          recipients: rows,
        });
        this.toast("success", `Penerima ${type} tersimpan (${rows.length})`);
        await this.loadRecipients();
      } catch (e) {
        this.toast("error", "Gagal menyimpan penerima");
      } finally {
        this.savingRecipients = null;
      }
    },
    async loadOverrides() {
      try {
        this.overrides = (await this.$store.dispatch("budgetMonitor/fetchOverrides")) || [];
        const page = await this.$store.dispatch("budgetMonitor/fetchPos", {
          band: "NO_BUDGET",
          includeClosed: true,
          page: 0,
          size: 100,
        });
        this.noBudgetPos = (page && page.items) || [];
      } catch (e) {
        this.noBudgetPos = [];
      }
    },
    async saveOverride(row, isNew) {
      if (
        !row.crmPoId ||
        row.marginPercent === null ||
        row.marginPercent === undefined ||
        row.marginPercent === ""
      ) {
        this.toast("warning", "Isi ID PO CRM dan margin %");
        return;
      }
      try {
        await this.$store.dispatch("budgetMonitor/saveOverride", {
          crmPoId: row.crmPoId,
          marginPercent: row.marginPercent,
          reason: row.reason,
        });
        this.toast(
          "success",
          "Override tersimpan. Jalankan 'Hitung ulang' agar budget PO terbarui."
        );
        if (isNew) this.newOverride = { crmPoId: null, marginPercent: null, reason: "" };
        await this.loadOverrides();
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message;
        this.toast("error", msg || "Gagal menyimpan override");
      }
    },
    async deleteOverride(row) {
      try {
        await this.$store.dispatch("budgetMonitor/deleteOverride", row.crmPoId);
        this.toast("success", "Override dihapus");
        await this.loadOverrides();
      } catch (e) {
        this.toast("error", "Gagal menghapus override");
      }
    },
    async sendTest() {
      this.sendingTest = true;
      try {
        await this.$store.dispatch("budgetMonitor/sendTestEmail", this.testEmail);
        this.toast("success", "Email uji terkirim");
        this.testDialog = false;
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message;
        this.toast("error", msg || "Gagal mengirim email uji");
      } finally {
        this.sendingTest = false;
      }
    },
  },
};
</script>
